import { createAction, props } from '@ngrx/store';

import { ITokenScope } from 'src/app/auth/auth.model';

import {
    AdvancedSearchForm,
    AvailableUserSearchForms,
    CreateUserRecordPayload,
    ProfileResponse,
    QuickSearchForm,
    UpdateUserRecordPayload,
    UserRecord,
    UserRecordResponse,
    secEmailState,
} from '../user.model';

export const GetProfileAction = createAction('[User] - Get Profile');

export const SetProfileAction = createAction('[User] - Set Profile', props<{ profile: ProfileResponse }>());

export const UpdateProfileAction = createAction('[User] - Update Admin Profile', props<{ payload: Partial<UpdateUserRecordPayload> }>());
export const UpdateProfileSuccessAction = createAction('[User] - Update Admin Profile Success');
export const UpdateProfileErrorAction = createAction('[User] - Update Admin Profile Error', props<{ error?: any }>());

export const FetchUserRecordAction = createAction('[User] - Fetch User Record', props<{ userid: string }>());

export const FetchUserRecordSuccessAction = createAction('[User] - Fetch User Record Success', props<{ userResponse: UserRecordResponse }>());

export const FetchUserRecordErrorAction = createAction('[User] - Fetch User Record Error', props<{ error?: any }>());

export const SetUserRecordAction = createAction('[User] - Set User Record', props<{ userRecord: UserRecord }>());

export const SetUserRecordSecEmailStateAction = createAction('[User: SecEmailState] - Set Communication Email State', props<{ userRecordSecEmailStatePayload: secEmailState }>());

export const CreateUserRecordAction = createAction('[User] - Create User Record', props<{ payload: CreateUserRecordPayload }>());

export const CreateUserRecordSuccessAction = createAction('[User] - Create User Record Success', props<{ id?: string }>());
export const CreateUserRecordErrorAction = createAction('[User] - Create User Record Error', props<{ error?: any }>());

export const UpdateUserRecordAction = createAction('[User] - Update User Record', props<{ payload: UpdateUserRecordPayload }>());
export const UpdateUserRecordSuccessAction = createAction('[User] - Update User Record Success');
export const UpdateUserRecordErrorAction = createAction('[User] - Update User Record Error', props<{ error?: any }>());

export const ManageUserRoleAction = createAction('[User] - Manage User Role', props<{ roleId: string; userid: string }>());
export const ManageUserRoleSuccessAction = createAction('[User] - Update User Record Success');
export const ManageUserRoleErrorAction = createAction('[User] - Manage User Error', props<{ error?: any }>());

export const AddUserRoleAction = createAction('[User] - Add User Role', props<{ roleId: string; userid: string }>());
export const AddUserRoleSuccessAction = createAction('[User] - Add User Role Success', props<{ user: any }>());
export const AddUserRoleErrorAction = createAction('[User] - Add User Role Error', props<{ error?: any }>());

export const RemoveUserRoleAction = createAction('[User] - Remove User Role', props<{ roleId: string; userid: string }>());
export const RemoveUserRoleSuccessAction = createAction('[User] - Remove User Record Success', props<{ user: any }>());
export const RemoveUserRoleErrorAction = createAction('[User] - Remove User Error', props<{ error?: any }>());

export const SetUserSearchUsersAction = createAction('[User] - Set User Search Users', props<{ users: any }>());

export const SetUserSearchTotalAction = createAction('[User] - Set User Search Total', props<{ total: number }>());

export const SetUserSearchQuickForm = createAction('[User] - Set User Search Quick Form', props<{ quickSearchForm: QuickSearchForm }>());

export const SetUserSearchAdvancedForm = createAction('[User] - Set User Search Advanced Form', props<{ advancedSearchForm: AdvancedSearchForm }>());

export const SetUserSearchActiveForm = createAction('[User] - Set User Search Active Form', props<{ activeForm: AvailableUserSearchForms }>());

export const SetUserSearchPageOptionsAction = createAction(
    '[User] - Set User Search Page Options',
    props<{
        pageIndex: number;
        itemsPerPage: number;
    }>(),
);

export const SearchUsersAction = createAction('[User] - Search Action');

export const SetUserScopesAction = createAction('[User] - Set User Scopes', props<{ scopes: ITokenScope[] }>());

export const SetUserSearchQuickFilters = createAction(
    '[User] - Set User Search Quick Filters',
    props<{
        cardsToApproveActive: boolean;
        familyLinksToApproveActive: boolean;
        residencesToApproveActive: boolean;
        moreFiltersData: Record<string, any>;
    }>(),
);

export const RefreshUserSubscriptionsAction = createAction('[User] - Refresh User Subscriptions');
